import { createContext } from 'react';
import noop from 'lodash/noop';

import { ByIdStructure, ModelOptions } from '../../../types';
import { Currency } from '../types';
import api from '../api';

interface Context<T> {
    get: (params?: Partial<T>, options?: ModelOptions, updateState?: boolean) => Promise<Array<T>>;
    getById: (id: string, params?: Partial<T>) => Promise<T[]>;
    getOne: (params: Partial<T>, body?: { populateQuery: Array<any> }) => Promise<T>;
    post: (body: Partial<T>, updateState?: boolean, last?: boolean) => Promise<T>;
    put: (body: Partial<T>) => Promise<T>;
    remove?: (id: string) => Promise<string>;
    softDelete: (body: { _id: string }) => Promise<any>;
    data: ByIdStructure<T>;
    setData: (obj: ByIdStructure<T>) => void;
    selected: T | null;
    setSelected: (object: T) => void;
    dataAsArray: T[];
    getSymbolByCurrency: (currencyId: Currency | Currency['_id'] | null) => string;
    getCodeByCurrency: (currencyId: Currency | Currency['_id'] | null) => string;
}

const CurrenciesContext = createContext<Context<Currency>>({
    get: api.get,
    getById: api.getById,
    getOne: api.getOne,
    post: api.post,
    put: api.put,
    remove: api.remove,
    softDelete: api.softDelete,
    data: { ids: [], byId: {} },
    setData: noop,
    selected: null,
    setSelected: noop,
    dataAsArray: [],
    getSymbolByCurrency: () => '',
    getCodeByCurrency: () => ''
});
export default CurrenciesContext;
